export const ANALYSIS_NOTE_MAX_LENGTH = 5000;
export const NOTE_MAX_LENGTH = 1024;
export const REPORT_ISSUE_DESCRIPTION_MAX_LENGTH = 2000;
export const REPORT_ISSUE_MAX_ATTACHMENTS = 3;
export const REPORT_ISSUE_MAX_IMAGE_SIZE_MB = 5;
export const REPORT_ISSUE_MAX_VIDEO_SIZE_MB = 10;
export const REPORT_ISSUE_MAX_TOTAL_SIZE_MB = 20;
export const SHARING_ADVISORS_MAX_COUNT = 5;
export const PENSION_PAYOUT_INTEREST_RATE = 2;
export const INFINITE_PENSION_PAYOUT_INTEREST_RATE = 4;
